import {observer} from "mobx-react";
import {ReactNode, useContext} from "react";
import {RecordingsStoreContext} from "../../../stores/RecordingsStore";
import styled from "@emotion/styled";
import {D} from "../../../Constants";
import {RecordingCard} from "../../recordings/RecordingCard";
import {recordings} from "../../../proto/compiled";
import {Typography} from "@mui/material";
import {Frame} from "../../common/Frame";
import {Pagination} from "../../system/Pagination";

interface SessionsProps {
  onSelect?: (recording: recordings.IRecording) => void;
}

export const Sessions = observer((props: SessionsProps) => {
  const store = useContext(RecordingsStoreContext)!;
  return <Frame paddingV={2}>
    <GridContainer>
      {renderRecordingCards(
        store?.recordings?.recordings ?? undefined,
        props.onSelect
      )}
      {!store.loading && store.recordings?.recordings?.length === 0 && (
        <EmptyState>Nothing recorded yet.</EmptyState>
      )}
    </GridContainer>
    {(store.recordings?.pagination?.nPages ?? 0) > 1 && <Pagination
      pagination={store.recordings!.pagination!}
      onPageChange={(page) => {
        store.recordings!.pagination!.page = page;
        store.load();
      }}
      onPageSizeChange={(pageSize) => {
        store.recordings!.pagination!.pageSize = pageSize;
        store.load();
      }}
      sticky={true}
    />}
  </Frame>;
});

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    overflow: hidden;
    gap: ${D.unit(2)};

    @media (max-width: 600px) {
        grid-template-columns: 1fr 1fr;
    }
`;

export const renderRecordingCards = (
  items?: recordings.IRecording[],
  onSelect?: (recording: recordings.IRecording) => void
) => (
  <>
    {items === undefined && <>
      <RecordingCard/>
      <RecordingCard/>
      <RecordingCard/>
      <RecordingCard/>
    </>}
    {items !== undefined && items.map(recording => (
      <RecordingCard
        key={recording.id}
        recording={recording}
        onClick={onSelect ? () => onSelect(recording) : undefined}
      />
    ))}
  </>
);

const EmptyState = ({children}: { children: ReactNode }) => (
  <Typography variant="body2" color="textSecondary" style={{gridColumn: "1 / -1", padding: D.unit(2)}}>
    {children}
  </Typography>
);
